import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from "@angular/core";

@Component({
    selector: "app-button-modal",
    templateUrl: "./button-modal.component.html",
    styleUrls: ['./button-modal.component.scss'],
    standalone: false
})
export class ButtonModalComponent implements OnChanges {
  @ViewChild('modal') modal: ElementRef;
  @Input() showModal: boolean = false;
  @Input() modalData: any = {};
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() confirmEvent: EventEmitter<any> = new EventEmitter<any>();

  close() {
    this.closeEvent.emit(true);
  }

  confirm() {
    this.confirmEvent.emit(true);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.setModalDefault();
    if (this.modal) {
      if (this.showModal) {
        this.modal.nativeElement.style.display = 'flex';
      } else {
        this.modal.nativeElement.style.display = 'none';
      }
    }
  }

  setModalDefault(): void {
    if (!this.modalData) {
      this.modalData = {};
    }
    this.modalData.icon = (this.modalData.icon) ? this.modalData.icon : '';
    this.modalData.titleIcon = (this.modalData.titleIcon) ? this.modalData.titleIcon : '';
    this.modalData.title = (this.modalData.title) ? this.modalData.title : '';
    this.modalData.body = (this.modalData.body) ? this.modalData.body : '';
    this.modalData.confirmButtonText = (this.modalData.confirmButtonText) ? this.modalData.confirmButtonText : '';
    this.modalData.closeButtonText = (this.modalData.closeButtonText) ? this.modalData.closeButtonText : '';
  }
}
